module.exports = __webpack_public_path__ + "static/media/microsoftazurecert.e7c78eba.jpg";